import type { ReactNode } from "react"
import { usePage } from "@inertiajs/react"
import { FlashMessages } from "@/components/flash-messages"
import { BottomNav } from "@/components/bottom-nav"
import { DeviceStatusProvider } from "@/hooks/use-device-status"
import { SimulatorProvider } from "@/hooks/use-simulator"
import { SimulatorFab } from "@/components/device-simulator/simulator-fab"

interface AppWrapperProps {
  children: ReactNode
}

export function AppWrapper({ children }: AppWrapperProps) {
  const { auth } = usePage<{ auth: { user: unknown } }>().props
  const signedIn = !!auth?.user

  if (!signedIn) {
    return (
      <>
        {children}
        <FlashMessages />
      </>
    )
  }

  return (
    <DeviceStatusProvider>
      <SimulatorProvider>
        <div className="pb-[calc(4rem+env(safe-area-inset-bottom))] md:pb-0">
          {children}
        </div>
        <FlashMessages />
        {import.meta.env.DEV && <SimulatorFab />}
        <BottomNav />
      </SimulatorProvider>
    </DeviceStatusProvider>
  )
}
